const snackbar = `[Snackbar] `;

const snackbarObject = {
  SNACKBAR_ERROR: `${snackbar} SNACKBAR_ERROR`,
  SNACKBAR_CLOSE: `${snackbar} SNACKBAR_CLOSE`,
};

export default snackbarObject;
